import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import URLS from "redux/urls";
import request from "redux/utils/request";

export const fetchAllDocument = createAsyncThunk(
  "Document/fetchAllDocument",
  async (params, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.DOCUMENT, params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addDocument = createAsyncThunk(
  "Document/addDocument",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request("post", URLS.DOCUMENT, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateDocument = createAsyncThunk(
  "Document/updateDocument",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request(
        "patch",
        `${URLS.DOCUMENT}/${payload.id}`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const fetchOneDocument = createAsyncThunk(
  "Document/fetchOneDocument",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.DOCUMENT}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteDocument = createAsyncThunk(
  "Document/deleteDocument",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.DOCUMENT}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loading: {
    query: false,
    mutation: false,
  },
  filter: {
    q: "",
  },
  list: [],
  count: {},
  selected: {},
  selectedRows: [],
};

const loadingReducer = (fieldName, status) => (state) => {
  state.loading[fieldName] = status;
};

const startLoadingQuery = loadingReducer("query", true);
const stopLoadingQuery = loadingReducer("query", false);
const startLoadingMutation = loadingReducer("mutation", true);
const stopLoadingMutation = loadingReducer("mutation", false);

export const DocumentSlice = createSlice({
  name: "Document",
  initialState,
  reducers: {
    setAppliedSearchText: (state, action) => {
      state.filter.q = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllDocument.pending, startLoadingQuery)
      .addCase(fetchAllDocument.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllDocument.rejected, stopLoadingQuery);
    builder
      .addCase(fetchOneDocument.pending, startLoadingQuery)
      .addCase(fetchOneDocument.rejected, stopLoadingQuery)
      .addCase(fetchOneDocument.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(updateDocument.pending, startLoadingQuery)
      .addCase(updateDocument.rejected, stopLoadingQuery)
      .addCase(updateDocument.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(deleteDocument.pending, startLoadingMutation)
      .addCase(deleteDocument.fulfilled, stopLoadingMutation)
      .addCase(deleteDocument.rejected, stopLoadingMutation);
  },
});

export const { setSelectedRows, setAppliedSearchText } = DocumentSlice.actions;

export default DocumentSlice.reducer;
